import * as React from 'react';

export default class SellerListItem extends React.Component {
  render = () => {
    const {
      cuit,
      estado,
      telefono,
      direccion,
      localidad,
      provincia,
      razonSocial,
      codigoPostal,
      emailContacto,
      numeroDomicilio,
      contactoComercial,
      onToggleStatus,
      onEdit // New prop
    } = this.props;


    const switchEstado = () => {
      switch (estado) {
        case "activo":
          return "ACTIVO"
        case "inactivo":
          return "INACTIVO"
        default:
          return ""
      }
    }

    const switchClass = () => {
      switch (estado) {
        case "activo":
          return "label label-success"
        case "inactivo":
          return "label label-danger"
        default:
          return "label"
      }
    }


    const renderStatusLabel = () => (
      <span
        style={{ width: "8em", textAlign: "center", cursor: "pointer", display: "inline-block", userSelect: "none" }}
        className={switchClass()}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onToggleStatus();
        }}
      >
        {switchEstado()}
      </span>
    );


    return (
      <div
        className="list-group-item hover-background-color"
        style={{ cursor: 'pointer' }}
        onClick={onEdit}
      >
        <div className="col-md-12 col-lg-12 col-12 col-sm-12 d-none d-sm-none d-md-block">

          <div className="row">

            <div className="col-md-3 col-lg-3">
              <h6 className="box-title m-b-5 font-weight-bold">{razonSocial}</h6>
              <small className="font-14 applyFont">{cuit}</small>
              <br />
            </div>

            <div className="col-md-4 col-lg-4">
              <small className="font-14 applyFont">
                <i className="fas fa-envelope" /> {emailContacto}
              </small>
              <br />
              <small className="font-14 applyFont">
                <i className="fas fa-phone" /> {telefono}
              </small>
            </div>

            <div className="col-md-3 col-lg-3">
              <small className="font-14 applyFont">
                <i className="fas fa-map-marker-alt" /> {direccion} {numeroDomicilio}
              </small>
              <br />
              <small className="font-14 applyFont">{codigoPostal} - {localidad}</small>
              <br />
              <small className="font-14 applyFont">{provincia}</small>
            </div>

            <div className="col-md-2 col-lg-2 col-4 align-self-center">
              {renderStatusLabel()}
            </div>
          </div>
        </div>

        {/* Vista Mobile */}
        <div className="col-md-8 col-lg-11 col-10 col-sm-10 d-block d-sm-block d-md-none">

          <div className="row">

            <div className="col-md-12 col-lg-12 col-12">
              <h6 className="box-title m-b-0 ">{razonSocial}</h6>
            </div>

            <div className="col-md-12 col-lg-12 col-12">
              <small className="applyFont">{contactoComercial}</small><br />
              <small >{emailContacto} | {telefono}</small>
            </div>

            <div className="col-md-10 col-lg-10 col-10 p-r-0">
              <small>{cuit}</small>
              <br />
              <small>{direccion} - {codigoPostal} - {localidad} - {provincia}</small>
            </div>

            <div className="col-md-2 col-lg-2 col-2 align-self-center">
              {renderStatusLabel()}
            </div>
          </div>
        </div>
      </div>
    );
  }

}